import type { TFunction } from 'i18next';

import { z } from 'zod';

export const createHobbiesSchema = (t: TFunction) =>
  z.object({
    hobbiesAndInterests: z
      .array(z.string().min(1, { message: t('Forms.HobbiesAndInterests.errors.hobby') }))
      .min(1, { message: t('Forms.HobbiesAndInterests.errors.minHobbies') })
      .max(10, { message: t('Forms.HobbiesAndInterests.errors.maxHobbies') }),
  });

export type HobbiesFormValues = z.infer<ReturnType<typeof createHobbiesSchema>>;
